import React from 'react';
import { useTranslation } from 'react-i18next';
import { Placement } from '@floating-ui/react';
import { Button } from '../../../../shared/components';
import { customDateStr } from '../../../../shared/misc/utils';
import DateInput from './DateInput';
import { TimelineMilestone } from '../../../../services/types/Timeline';

interface MilestoneProps {
  milestone: TimelineMilestone;
  isEditing: boolean;
  toggleEdition: () => void;
  saveDate: (milestoneId: number, date: Date | null) => void;
  setMilestoneCalendarOpened?: (milestoneId: number | null) => void;
  calendarDirection?: Placement;
  onSnake: boolean;
}

const MilestoneDateEditable = (props: MilestoneProps) => {
  const {
    milestone,
    isEditing,
    toggleEdition,
    setMilestoneCalendarOpened,
    saveDate,
    calendarDirection,
    onSnake,
  } = props;
  const { t } = useTranslation();

  let displayDate = onSnake
    ? milestone.compassDate || milestone.convergenceDate
    : milestone.compassDate;
  displayDate = displayDate ? customDateStr(displayDate) : t('notSet');

  return !isEditing ? (
    <Button
      text={displayDate || ''}
      onClick={toggleEdition}
      className="btn-tertiary date-editable"
    />
  ) : (
    <DateInput
      onCancel={toggleEdition}
      onSave={(date) => {
        saveDate(milestone.milestoneId, date);
        toggleEdition();
      }}
      value={milestone.compassDate || milestone.convergenceDate}
      calendarDirection={calendarDirection}
      handleOpen={() => {
        if (setMilestoneCalendarOpened) {
          setMilestoneCalendarOpened(milestone.milestoneId);
        }
      }}
      handleClose={() => {
        if (setMilestoneCalendarOpened) {
          setMilestoneCalendarOpened(null);
        }
      }}
    />
  );
};

export default MilestoneDateEditable;
